<template>
  <div class="back-button" @click="$emit('back')">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19 12H5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M12 19L5 12L12 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
    <slot>Back</slot>
  </div>
</template>

<script>
export default {
  name: 'BackButton',
  emits: ['back']
}
</script>

<style scoped>
.back-button {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  color: #666;
  font-size: 16px;
  padding-left: 0px;
  padding-right: 0px;
  padding-top: 8px;
  padding-bottom: 8px;
  transition: all 0.3s ease;
}

.back-button:hover {
  background-color: #4b4a4a0e;
  color: #4b4a4a;
  padding: 8px;
  border-radius: 10px;
  transform: translateX(-2px);
}

.back-button svg {
  width: 24px;
  height: 24px;
}
</style> 